// extracted by mini-css-extract-plugin
module.exports = {"SimpleLink":"SimpleLink_SimpleLink__UWeQJ","linkContent":"SimpleLink_linkContent___BjJA"};